<template>
    <div class="input-group">
        <input :type="show ? 'text' : 'password'"
            dusk="loginForm:password"
            class="form-control form-control-lg req"
            :name="fieldName"
            :id="inputId"
            required="">
        <a v-on:click="switchType" href="javascript:void(0)" class="input-group-text">
            <template>
            <eye-icon size="1.5x" class="custom-class"></eye-icon>
            </template>
        </a>
    </div>
</template>
<script>

import { EyeIcon } from 'vue-feather-icons';
import { EyeOffIcon } from 'vue-feather-icons'

export default {
    data() {
        return {
            show: false,
        }
    },

    props: ['value', 'config'],

    components: {
        EyeIcon,
        EyeOffIcon
    },

    watch: {
        value(newVal) {

        },
    },

    computed: {
        cssClass() {
            return _.get(this.config, 'cssClass', '')
        },

        fieldName() {
            return _.get(this.config, 'fieldName', 'password')
        },

        inputId() {
            return _.get(this.config, 'id', 'password')
        },
    },

    methods: {
        switchType() {
            this.show = !this.show;
        }
    }
}
</script>
